import { useState } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { useAuth } from "../contexts/AuthContext";
import ThemeToggle from "../components/ui/ThemeToggle";

export default function LoginPage({ onGoToRegister }) {
  const { C, isDark } = useTheme();
  const { login, loading, error } = useAuth();
  // Campos vazios em produção — defaults de dev removidos (vetor de exposição
  // mínimo, mas desnecessário). Browser autocomplete cobre conveniência local.
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    await login(email, senha);
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: C.bg,
        fontFamily: "'DM Sans', sans-serif",
        transition: "background 0.3s ease",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: 380,
          padding: 40,
          background: C.bgCard,
          borderRadius: 20,
          border: `1px solid ${C.border}`,
          boxShadow: isDark
            ? "0 20px 60px rgba(0,0,0,0.4)"
            : "0 20px 60px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src="/tecmovel-logo.png"
            alt="Tecmovel"
            style={{
              width: 72,
              height: 72,
              objectFit: "contain",
              marginBottom: 12,
            }}
          />
          <p style={{ fontSize: 12, color: C.textMuted, marginTop: 12 }}>
            turismo.tecmovel.com.br
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: C.textMuted,
                display: "block",
                marginBottom: 6,
              }}
            >
              E-mail
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              type="email"
              required
              autoComplete="email"
              style={inputStyle(C)}
            />
          </div>
          <div>
            <label
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: C.textMuted,
                display: "block",
                marginBottom: 6,
              }}
            >
              Senha
            </label>
            <input
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              type="password"
              placeholder="••••••••"
              required
              autoComplete="current-password"
              style={inputStyle(C)}
            />
          </div>

          {error && (
            <div
              style={{
                background: C.redDim,
                color: C.red,
                padding: "10px 14px",
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "13px",
              borderRadius: 10,
              border: "none",
              background: `linear-gradient(135deg, ${C.accent}, ${C.accentLight})`,
              color: isDark ? "#0B1219" : "#fff",
              fontSize: 14,
              fontWeight: 700,
              cursor: loading ? "wait" : "pointer",
              fontFamily: "'DM Sans', sans-serif",
              marginTop: 4,
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>

          {/* Link pra tela de cadastro — só aparece se o caller (App.jsx)
              passou o callback. Mantém retrocompat se LoginPage for
              renderizada em outro contexto sem cadastro. */}
          {onGoToRegister && (
            <button
              type="button"
              onClick={onGoToRegister}
              style={{
                background: "none",
                border: "none",
                color: C.textMuted,
                fontSize: 12,
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                padding: "8px 0",
                textAlign: "center",
              }}
            >
              Não tem conta?{" "}
              <span style={{ color: C.accent, fontWeight: 600 }}>Criar conta</span>
            </button>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
          <ThemeToggle collapsed={false} />
        </div>

        <p style={{ textAlign: "center", fontSize: 11, color: C.textDim, marginTop: 20 }}>
          Tecmovel Sistemas · v1.0.0
        </p>
      </form>
    </div>
  );
}

function inputStyle(C) {
  return {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 10,
    border: `1px solid ${C.border}`,
    background: C.inputBg,
    color: C.text,
    fontSize: 14,
    outline: "none",
    fontFamily: "'DM Sans', sans-serif",
    boxSizing: "border-box",
  };
}
